export function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function capitalizeAll(str: string): string {
    return str.replace(/\w\S*/g, function(word: string): string {
        return capitalize(word);
    });
}
